module.exports = __webpack_public_path__ + "static/media/kingmaker.c59dbedf.png";